export const PDF_DATA_URI_PREFIX = 'data:application/pdf;base64,';
export const PNG_DATA_URI_PREFIX = 'data:image/png;base64,';
export const DEFAULT_CERTIFICATE_PDF_FILENAME = 'certificate.pdf';
export const DEFAULT_CERTIFICATE_PNG_FILENAME = 'certificate.png';
